/**
 * 系统日志管理 Composable
 * 管理系统日志的添加、显示等功能
 */

export default function useSystemLog() {
  return {
    data() {
      return {
        systemLogs: [],
        maxLogCount: 6
      };
    },

    methods: {
      /**
       * 添加系统日志
       * @param {string} message - 日志消息
       */
      addSystemLog(message) {
        const now = new Date();
        const timeString = `${now
          .getHours()
          .toString()
          .padStart(2, '0')}:${now
          .getMinutes()
          .toString()
          .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;

        const newLog = {
          time: timeString,
          message: message,
          id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
        };

        this.systemLogs.unshift(newLog);

        if (this.systemLogs.length > this.maxLogCount) {
          this.systemLogs = this.systemLogs.slice(0, this.maxLogCount);
        }
      }
    }
  };
}
